import {CaretRightOutlined as AntdCaretRightOutlined} from '@ant-design/icons';

export default function CaretRightOutlined(props) {
  return <AntdCaretRightOutlined {...props} />;
}
